import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import masonry from 'alpinejs-masonry'
import persist from '@alpinejs/persist'
import { gsap } from 'gsap'
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin'
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

import stateManager from '@/StateManager'
import core from '@/core'
import router from '@/Router'

Alpine.plugin(focus)
Alpine.plugin(masonry)
Alpine.plugin(persist)
window.Alpine = Alpine

gsap.registerPlugin(DrawSVGPlugin, MorphSVGPlugin, ScrollTrigger, SplitText)
window.gsap = gsap
window.mm = gsap.matchMedia()
window.ScrollTrigger = ScrollTrigger
window.SplitText = SplitText

stateManager()
core()
router()

console.log(
    `%cbuilt with ❤ by humans @ https://whiteboard.is.`,
    'background: #e21c3f; color: #ffffff; font-size: 13px; padding: 4px 8px;',
)
